import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import { ACTIVITY_STATUS, DATE_FORMATS } from "../../constants";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import moment from "moment";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { Link } from "react-router-dom";

const isMobile = window.innerWidth < 900;


const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding:10px;
`;

const InputFieldContainer = styled.div`
  margin: 20px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap:10px;
  label{
    margin-bottom: 0px;
  }
`;
// const StyledContainer = styled.div`
//   /* Default styles */
//   width: 100%;
//   max-width: 960px;
//   margin: 0 auto;
  
//   /* Mobile styles */
//   @media (max-width: 600px) {
//     padding: 0 10px;
//   }
// `;
const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top:10px;
`;
const FirstButton = styled(Button)`
  margin-right: 10px !important;
`;

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const StyledDialog = styled(Dialog)`
  position: relative;
`;

const DataGridContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
  
//   height: 500px;
  padding:10px;
`;

const NoteText = styled(Typography)`
  margin-top: 10px !important;
`;

const Input = styled.input`
  display: none;
`;
  
  const TimelineSo = ({ onClose, timeline }) => {
// console.log('timeee,', timeline)
const [data,setData]=useState([]);
const [loading,setLoading]=useState(false);

useEffect(()=>{
   fetchData()
localStorage.removeItem('typeShip');

   localStorage.removeItem('editTime');
   localStorage.removeItem('wid');
  
   localStorage.removeItem('phase');
  },[timeline])

  const fetchData = async () => {
    // console.log("timmeeee",timeline)
    try{
      setLoading(true)
// let date = moment(timeline).format(DATE_FORMATS.DEFAULT)


          let results = await window.Platform.database.fetchSoByExpectedDate(timeline)
          setData(results)
          // console.log('resilts', results)
setLoading(false)
  }
  catch(err){
    setLoading(false)
// console.log('error', err)
  }
}

const setLocalStorage=()=>{

//   const inputDate = new Date(timeline.date);

// // Adjust the time to UTC
// const utcTime = inputDate.getTime() - (inputDate.getTimezoneOffset() * 60000); // Convert to UTC

// // Format the UTC time as required ("YYYY-MM-DDTHH:mm:ss.sssZ")
// const formattedDateString = new Date(utcTime).toISOString();
// console.log("FORMATTEDDATE",formattedDateString);
  localStorage.setItem("mode",timeline.mode)
  localStorage.setItem('time',timeline.date);
  localStorage.removeItem("phase")
}

  const getItemColumns = () => {
    let result = [
        {
            field: "soId",
            headerName: "SO Id",
            sortable: false,
            width: 150,
            // editable: false,
            renderCell: params => {
              // console.log("PARAMS", params.row.quotation.attributes.customerName);
              const value = params.row.id || 'N/A'
              return <Tooltip title={value}>{value}</Tooltip>
            }
          },
          {
            field: "customerName",
            headerName: "Customer Name",
            width: 200,
            sortable: false,
            // dataGetter: params => params.row.customer?.name || 'N/A',
            renderCell: params => {
              const value = params.row.quotation.attributes.customerName || 'N/A'
              return <Tooltip title={value}>{value}</Tooltip>
            }
    
          },
          
          {
            field: "supplierName",
            headerName: "Supplier Name",
            width: 200,
            sortable: false,
            // dataGetter: params => params.row.supplier?.name || 'N/A',
            renderCell: params => {
              const value = params.row.quotation.attributes.supplierName || 'N/A'
              return <Tooltip title={value}>{value}</Tooltip>
            }
          },
          {
            field: "totalVol",
            headerName: "Total Volume",
            width: 200,
            sortable: false,
            dataGetter: params => params.row.totalVolume || 'N/A',
            renderCell: params => {
              const value = params.row.totalVolume 
              return <Tooltip title={value}>{value}</Tooltip>
            }
          },
          {
            field: "totalCbm",
            headerName: "Total CBM",
            width: 200,
            sortable: false,
            // dataGetter: params => params.row.supplier?.deliveryDate || 'N/A',
            renderCell: params => {
              const value =params.row.totalCbm 
              return <Tooltip title={value}>{value}</Tooltip>
            }
          },
          {
            field: "totalWeight",
            headerName: "Total Weight",
            width: 200,
            sortable: false,
            // dataGetter: params => params.row.status || 'N/A',
            renderCell: params => {
              const value =params.row.totalWeight
              return <Tooltip title={value}>{value}</Tooltip>
            }
          },
          {
            field: "totalAmount",
            headerName: "Total Amount",
            width: 200,
            sortable: false,
            dataGetter: params => params.row.status || 'N/A',
            renderCell: params => {
              const value =params.row.totalAmount
              return <Tooltip title={value}>{value}</Tooltip>
            }
          },
          
          // {
          //   field: "shipmentType",
          //   headerName: "Shipment Type",
          //   width: 200,
          //   sortable: false,
          //   dataGetter: params => params.row.shipmentType || 'N/A',
          //   renderCell: params => {
          //     const value = params.row.shipmentType || 'N/A'
          //     return <Tooltip title={value}>{value}</Tooltip>
          //   }
          // },
        
         
      
    ];
  
  
    return result
  }
  
    function CustomToolbar() {
      return (
        <GridToolbarContainer>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
          <GridToolbarExport
            csvOptions={{
              fileName: "items-list",
            }}
          />
        </GridToolbarContainer>
      );
    }
  
    const renderContent = () => {
      return (
        <DataGridContainer>
            {/* <Stack> */}

        {/* <Box sx={{ height: "100%", width: "100%" }}> */}
          <DataGrid
            sx={{height:isMobile ? "300px":"300px"}}
            className="payrollGrid"
            // checkboxSelection={true}
            rows={data||[]}
            columns={getItemColumns()}
            rowHeight={70}
            disableSelectionOnClick
            disableRowSelectionOnClick
            autoPageSize
            // components={{
            //     Toolbar: CustomToolbar,
            // }}
            />
        {/* </Box> */}
            {/* </Stack> */}
            <ModalActionsContainer>
                
        <Stack
                direction="row"
                justifyContent="flex-end"
                gap="10px"
                align-items="center"
                >
<Link to={`/containerplanning/${timeline.wid}`} component="button" onClick={data.length===0&&((event) => event.preventDefault())}>
                <Button variant="contained" onClick={()=>setLocalStorage()}  disabled={data.length===0} >Plan Container</Button>
</Link>
              </Stack>
                  </ModalActionsContainer>
        </DataGridContainer>
      );
    };
  
    return (
      <Dialog open={true}  maxWidth="lg">

      <ModalHeaderContainer style={{ marginBottom: 0, paddingBottom: 0 }}>

        <Typography variant="h5">

          {/* {items?.customerName} */}

          SO(s) expected delivery on {moment.unix(timeline.date).format(DATE_FORMATS.DEFAULT)}


 

       </Typography>
       <IconButton  onClick={()=>onClose()}>
            <CloseOutlinedIcon />
          </IconButton>
       </ModalHeaderContainer>
       {loading && <OpaqueLoading/>}
      
      {renderContent()}

      {/* {showModal && <EditQuotationModal template={items} onCancel={()=>setShowModal(false)}/>} */}

    </Dialog>
    );
  };
  
  export default TimelineSo;
  